<template>
  <div class="about-page">
    <!-- Hero Section -->
    <section class="hero-section">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" class="text-center">
            <h1 class="hero-title mb-2">영어문 서비스는?</h1>
            <div class="hero-subtitle mb-8">How it works</div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Features Section -->
    <section class="features-section">
      <v-container>
        <v-row>
          <!-- Left Column -->
          <v-col cols="12" md="6">
            <router-link class="text-decoration-none" to="/main/class-info">
              <v-card class="feature-card mb-6" rounded="lg" elevation="3">
                <div class="card-content">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-information-outline</v-icon>
                  </div>
                  <h3 class="card-title">운영방식</h3>
                  <v-divider class="my-3"></v-divider>
                  <div class="card-features">
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>화상/음성 동일 가격</span>
                    </div>
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>영수증, 출석증 발급</span>
                    </div>
                  </div>
                  <div class="more-link">더보기 <v-icon small>mdi-arrow-right</v-icon></div>
                </div>
              </v-card>
            </router-link>

            <router-link class="text-decoration-none" to="/main/content">
              <v-card class="feature-card" rounded="lg" elevation="3">
                <div class="card-content">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-account-supervisor</v-icon>
                  </div>
                  <h3 class="card-title">1:1 집중관리</h3>
                  <v-divider class="my-3"></v-divider>
                  <div class="card-features">
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>문법 오류 교정</span>
                    </div>
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>단계별 맞춤 수업</span>
                    </div>
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>유아부터 성인까지</span>
                    </div>
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>다양한 주제 및 시험대비</span>
                    </div>
                  </div>
                  <div class="more-link">더보기 <v-icon small>mdi-arrow-right</v-icon></div>
                </div>
              </v-card>
            </router-link>
          </v-col>
          
          <!-- Right Column -->
          <v-col cols="12" md="6">
            <router-link class="text-decoration-none" to="/main/teacher">
              <v-card class="feature-card mb-6" rounded="lg" elevation="3">
                <div class="card-content">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-account-tie</v-icon>
                  </div>
                  <h3 class="card-title">원어민 선생님</h3>
                  <v-divider class="my-3"></v-divider>
                  <div class="card-features">
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>담당 선생님 지정</span>
                    </div>
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>고정된 수업 시각</span>
                    </div>
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>전문 교육과정 수료</span>
                    </div>
                    <div class="feature-item">
                      <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                      <span>전화영어 센터 출신</span>
                    </div>
                  </div>
                  <div class="more-link">더보기 <v-icon small>mdi-arrow-right</v-icon></div>
                </div>
              </v-card>
            </router-link>

            <router-link class="text-decoration-none" to="/main/guide/call">
              <v-card class="feature-card" rounded="lg" elevation="3">
                <div class="card-content">
                  <div class="icon-wrapper">
                    <v-icon color="primary" size="36">mdi-phone-in-talk</v-icon>
                  </div>
                  <h3 class="card-title">전화 or 화상</h3>
                  <v-divider class="my-3"></v-divider>
                  <div class="app-icons">
                    <v-img 
                      :src="`${app.cdnUrl}/website/button/btn_zoom.png`"
                      width="50px"
                      height="50px"
                      class="app-icon"
                    />
                    <v-img 
                      :src="`${app.cdnUrl}/website/button/btn_teams.png`"
                      width="50px"
                      height="50px"
                      class="app-icon"
                    />
                  </div>
                  <div class="more-link">더보기 <v-icon small>mdi-arrow-right</v-icon></div>
                </div>
              </v-card>
            </router-link>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Course',
  data() {
    return { }
  },
  components: {},
  computed: {
    ...mapGetters(['app']),
    subTitleProcess(){return this.app.sysconf.filter(s => s.code === 'en9door_INFO_CONTENT_PROCESS').map(s => s.value).toString()},
    subTitleTeacher(){return this.app.sysconf.filter(s => s.code === 'en9door_INFO_CONTENT_TEACHER').map(s => s.value).toString()},
    subTitleContent(){return this.app.sysconf.filter(s => s.code === 'en9door_INFO_CONTENT_BOOK').map(s => s.value).toString()},
    isMobile: function (){
      return this.isMobile
    },
    desktopCardHeight: function() {
      return this.isMobile === false ? 320 : undefined
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
@import "@/assets/scss/elegant-theme.scss";

.about-page {
  background-color: #f9f9f9;
  min-height: 100vh;
}

.hero-section {
  padding: 60px 0 30px; 
  
  .hero-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #334155;
    margin-bottom: 0.5rem;
    letter-spacing: -0.5px;
  }
  
  .hero-subtitle {
    font-size: 1.2rem;
    color: #64748b;
    font-weight: 500;
  }
}

.features-section {
  padding: 30px 0 80px;
  margin-top: -20px;
}

.feature-card {
  height: 100%;
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1) !important;
  }
  
  .card-content {
    padding: 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .icon-wrapper {
    background-color: rgba(59, 130, 246, 0.1);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }
  
  .card-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1e40af;
    margin-bottom: 0;
  }
  
  .card-features {
    margin-top: 16px;
    flex-grow: 1;
  }
  
  .feature-item {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    
    span {
      font-size: 1rem;
      color: #334155;
    }
  }
  
  .more-link {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #2563eb;
    font-weight: 600;
    margin-top: 12px;
    transition: all 0.2s ease;
    
    &:hover {
      color: #1e40af;
      transform: translateX(5px);
    }
  }
}

.app-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 20px 0;
}

.app-icon {
  border-radius: 12px;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  &:hover {
    transform: scale(1.1);
  }
}

// Responsive adjustments
@media (max-width: 960px) {
  .hero-section {
    padding: 40px 0 20px;
    
    .hero-title {
      font-size: 2rem;
    }
    
    .hero-subtitle {
      font-size: 1rem;
    }
  }
  
  .feature-card {
    margin-bottom: 20px;
    
    .card-content {
      padding: 20px;
    }
    
    .card-title {
      font-size: 1.3rem;
    }
  }
}
</style>
